import * as React from 'react';
import {SystemPopup } from '../../../library';
import AuditGrid from './AuditGrid'
interface IAuditFormProps {
    visible: boolean, table: string, schema: string,
    secondaryTable: string, secondarySchema: string,
    onClose(): void, primaryKeyEncrypted: string, secondaryKeyEncrypted: string
}

interface IAuditFormState {
    ContextId: string,

}
export default class AuditForm extends React.Component<IAuditFormProps, IAuditFormState> {
    constructor(props: any) {
        super(props);
        this.state = { ContextId: '' }


    }

    onRowClick = (data: any) => {
        if (data && data.ContextId) {
            this.setState({ ContextId: data.ContextId })
        }
    }
    render() {        
        return <SystemPopup visible={this.props.visible} onClose={this.props.onClose} >

            <AuditGrid Schema={this.props.schema}
                Table={this.props.table}
                secondarySchema={this.props.secondarySchema}
                secondaryTable={this.props.secondaryTable}
                primaryKey={this.props.primaryKeyEncrypted}
                secondaryKey={this.props.secondaryKeyEncrypted} />

        </SystemPopup >
    }
}

